import Swiper from '@src/components/swiper';
import { screenResizerChecker } from '@src/utils/screen-resizer-checker';
import { ScreensInt } from '@tailwindConfig/screens.config';

document.addEventListener("DOMContentLoaded", function(_event) {
  let mySwiper;

  const generateSwiper = () => {
    if (!mySwiper) {
      mySwiper = new Swiper('.swiper-pricing-cards', {
        // Default parameters
        slidesPerView: 1.3,
        centeredSlides: false,
        spaceBetween: 55,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      })
    }
  }

  const removeSwiper = () => {
    if (mySwiper) {
      $('.swiper-pricing-cards').each(function(){
        this.swiper.destroy();
      });
      mySwiper = null;
    }
  }

  screenResizerChecker(() => generateSwiper(), () => removeSwiper(), ScreensInt.md);
});
